import React from 'react';
import ImageLoader from 'components/image-loader';
import { ProvinceOrStateCode, isUsStateCode } from 'utils/province_or_state';
import styles from './style.module.scss';
import { useTranslation } from 'next-i18next';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';

import type { ListingCardData } from 'components/listing-card/listing-card';

interface Props {
  listing: ListingCardData;
  isSmallCard?: boolean;
  isOnMapSidePanel?: boolean;
}

export default function ProviderLogo({ listing, isSmallCard = false, isOnMapSidePanel = false }: Props) {
  const { t } = useTranslation(Namespaces.COMMON);
  const { province, providerId } = listing;
  // This logo is never per-provider here, so it always takes the generic label.
  const logoAlt = t(LOCALE_COMMON_PATHS.LISTING_CARD_PROVIDER_LOGO_ALT, { context: 'default', defaultValue: 'MLS logo' });
  const isAmericanListing = isUsStateCode(province?.toLowerCase() as ProvinceOrStateCode);
  const wrapperClassname = isSmallCard ? styles['wrapper-small'] : !isOnMapSidePanel ? styles.wrapper : '';

  if (!isAmericanListing) {
    return null;
  }

  return (
    <div className={wrapperClassname}>
      <div className={styles.component}>
        <ImageLoader className={styles['provider-logo']} src={`https://zoocasa.s3.amazonaws.com/provider-logos/PROV_LOGO_${providerId}.png`} alt={logoAlt} />
      </div>
    </div>
  );
}
